'use strict';

var EditTrafficPolicy = require('actionGroups/trafficPolicy/TrafficPolicy');

module.exports = {
  Model: EditTrafficPolicy,
};
